import React from 'react'
import { Tooltip } from '@components/tooltip.component'
import { toastService } from '@utils/toast.service'

type CopyTextBarProps = {
  shareText: string
  className?: string
}

export function CopyTextBar({ shareText, className = '' }: CopyTextBarProps) {
  async function copyToClipboard() {
    await navigator.clipboard.writeText(shareText)
    toastService.info('Copied to clipboard')
  }

  return (
    <div className={`flex-ellipsis ${className}`}>
      <Tooltip content="Copy">
        <button
          onClick={copyToClipboard}
          aria-label={`Click to copy share link ${shareText}`}
          className="w-full box-border cursor-pointer overflow-hidden whitespace-nowrap rounded-[var(--base-border-radius)] border-0 bg-grey-75 px-2 py-1 text-ellipsis leading-normal transition-colors duration-200 ease-in-out hover:bg-grey-100"
        >
          {shareText}
        </button>
      </Tooltip>
    </div>
  )
}
